import {AxiosError} from 'axios';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {POST_RESIT_CONFIRM_AND_PAY} from '../../constants/apiUrls';
import {ResitSubject} from '../../api/candidate/resit/model';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface ResitSubjectWithAccessLinkRequest {
  subjects: ResitSubject[];
  accessLinkToken: string | null;
  paymentMode: string;
}

export interface PostCandidateRegistrationResponse {
  internalTransactionRef: string;
  paymentSuccess: boolean;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: PostCandidateRegistrationResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostConfirmAndPay = ({onSuccess, onError}: Input = {}) => {
  const postConfirmAndPay = async (payload: {
    uuid: string;
    resitSubjects: ResitSubjectWithAccessLinkRequest;
  }) => {
    const res = await axiosClient.post<PostCandidateRegistrationResponse>(
        POST_RESIT_CONFIRM_AND_PAY(payload.uuid),
        payload.resitSubjects
    );
    return res.data;
  };

  return useCustomMutation(postConfirmAndPay, {
    onSuccess,
    onError,
  });
};
